module.exports = __webpack_public_path__ + "static/app-home-d04f8dcb55bee3add52c5be3dbc24de4.png";